import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchMessageAttachmentObjectUrl } from "../reducers/messageSlice";

const getAttachmentObjectUrlAsync = async (dispatch, sourceUrl, attachmentId) => {
    if (attachmentId) {
        return await dispatch(fetchMessageAttachmentObjectUrl(attachmentId)).unwrap();
    }

    return sourceUrl;
}

export const useAttachmentUrl = (sourceUrl, attachmentId = null) => {
    const dispatch = useDispatch();
    const [resolvedUrl, setResolvedUrl] = useState(null);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        let objectUrl = null;
        let isDisposed = false;

        setResolvedUrl(null);
        setHasError(false);

        if (!sourceUrl && !attachmentId) {
            return;
        }

        getAttachmentObjectUrlAsync(dispatch, sourceUrl, attachmentId)
            .then(url => {
                objectUrl = url;
                if (!isDisposed) {
                    setResolvedUrl(url);
                    return;
                }

                URL.revokeObjectURL(url);
            })
            .catch(() => {
                if (!isDisposed) {
                    setHasError(true);
                }
            });

        return () => {
            isDisposed = true;
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [dispatch, sourceUrl, attachmentId]);

    return { hasError, resolvedUrl };
}
